import { throttle } from 'lodash';
import { useEffect, useState } from 'react';

import { isBrowser } from '@utils/isBrowser';

import theme from '@theme/FolxTheme';

export default (
	breakpoint = theme.responsive.sizes.tablet,
	tabletBreakpoint = theme.responsive.sizes.laptop,
	laptopBreakpoint = theme.responsive.sizes.desktop
) => {
	const [isMobile, setIsMobile] = useState(
		isBrowser ? (window?.innerWidth ?? 0) < Number.parseInt(breakpoint) : false
	);
	const [isTablet, setIsTablet] = useState(
		isBrowser ? (window?.innerWidth ?? 0) < Number.parseInt(tabletBreakpoint) : false
	);
	const [isLaptop, setIsLaptop] = useState(
		isBrowser ? (window?.innerWidth ?? 0) < Number.parseInt(laptopBreakpoint) : false
	);
	const [isDesktop, setIsDesktop] = useState(
		isBrowser ? (window?.innerWidth ?? 0) > Number.parseInt(laptopBreakpoint) : false
	);
	const [windowSize, setWindowSize] = useState('');

	useEffect(() => {
		setWindowSize(
			isMobile ? 'mobile' : isTablet ? 'tablet' : isLaptop ? 'laptop' : isDesktop ? 'desktop' : ''
		);
	}, [isMobile, isTablet, isDesktop]);

	useEffect(() => {
		if (!isBrowser) {
			setIsMobile(false);
			setIsTablet(false);
			setIsLaptop(false);
			setIsDesktop(false);
			return;
		}

		const updateMobileState = () => {
			setIsMobile((window?.innerWidth ?? 0) < Number.parseInt(breakpoint));
			setIsTablet((window?.innerWidth ?? 0) < Number.parseInt(tabletBreakpoint));
			setIsLaptop((window?.innerWidth ?? 0) < Number.parseInt(laptopBreakpoint));
			setIsDesktop((window?.innerWidth ?? 0) >= Number.parseInt(laptopBreakpoint));
		};

		const handleResize = throttle(updateMobileState, 60);

		window.addEventListener('resize', handleResize);
		return () => {
			isBrowser && window.removeEventListener('resize', updateMobileState);
		};
	}, []);

	return { isMobile, isTablet, isLaptop, isDesktop, windowSize };
};
